import { toast } from "react-toastify";
import { HTTPURL } from "../constants/Matcher";

const base = `${HTTPURL}api`;

const toQs = (params) => {
  const clean = Object.fromEntries(
    Object.entries(params || {}).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );
  return new URLSearchParams(clean).toString();
};

export async function answer_booklets(params = {}) {
  const qs = toQs(params);
  try {
    const res = await fetch(`${base}/answer-booklets${qs ? `?${qs}` : ""}`);
    return await res.json();
  } catch (e) {
    return { status: false, message: e.message, data: [] };
  }
}

// formData: file, year, grade_id, term, subject_id, user_id
export async function answer_booklet_save(formData) {
  try {
    const res = await fetch(`${base}/answer-booklet`, {
      method: "POST",
      body: formData,
    });
    const data = await res.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}

export async function answer_booklet_delete(id) {
  try {
    const res = await fetch(`${base}/answer-booklet-delete?id=${id}`, {
      method: "POST",
    });
    const data = await res.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}
